import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsDateString,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  Min,
  ValidateNested,
} from 'class-validator';
import { MAX_BATCH_ARRAY_SIZE } from '../../constants/validation.constants';
import { FryerOilRecordType } from './fryer-oil-record-type.enum';

export class SignOilBatchItemDto {
  @IsString()
  fryerId!: string;

  @IsDateString()
  date!: string;

  @IsEnum(FryerOilRecordType)
  recordType!: FryerOilRecordType;

  @IsNumber()
  @IsOptional()
  @Min(0)
  tpiValue?: number;

  @IsString()
  @IsOptional()
  notes?: string;
}

export class SignOilBatchDto {
  @IsArray()
  @ArrayMaxSize(MAX_BATCH_ARRAY_SIZE)
  @ValidateNested({ each: true })
  @Type(() => SignOilBatchItemDto)
  records!: SignOilBatchItemDto[];

  @IsString()
  signatureImage!: string;
}
